import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "version" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "login-box" }
const _hoisted_5 = {
  key: 0,
  class: "danger reset-hint"
}

export function render(_ctx, _cache) {
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_affix = _resolveComponent("el-affix")
  const _component_User = _resolveComponent("User")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_Lock = _resolveComponent("Lock")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_affix, { offset: 0 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "logo",
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onLogoClick && _ctx.onLogoClick(...args)))
          }, [
            _createVNode(_component_el_image, { src: "/img/ddg-logo-128.png" })
          ]),
          _createElementVNode("div", {
            class: _normalizeClass('logo-line' + ((_ctx.windowWidth < 768) ? '-mobile' : ''))
          }, _cache[5] || (_cache[5] = [
            _createTextVNode(" MC.health"),
            _createElementVNode("br", null, null, -1),
            _createTextVNode("Prüfungsplattform ")
          ]), 2),
          _createElementVNode("div", _hoisted_2, " V. " + _toDisplayString(_ctx.environmentVersion), 1)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_Transition, { name: "el-zoom-in-center" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_form, {
              modelValue: _ctx.userModel,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.userModel) = $event)),
              ref: "form",
              onSubmit: _withModifiers(_ctx.onLoginClick, ["prevent"])
            }, {
              default: _withCtx(() => [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "field-label-login" }, " Login ", -1)),
                _createVNode(_component_el_form_item, {
                  class: "field",
                  prop: "username"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.userModel.username,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.userModel.username) = $event)),
                      class: "field-input-user",
                      placeholder: "Benutzer",
                      disabled: _ctx.loading,
                      onInput: _ctx.onInput,
                      autofocus: true
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_User)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled", "onInput"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  class: "field",
                  prop: "password"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.userModel.password,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.userModel.password) = $event)),
                      class: "field-input-password",
                      type: "password",
                      placeholder: "Passwort",
                      disabled: _ctx.loading,
                      onInput: _ctx.onInput
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Lock)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled", "onInput"])
                  ]),
                  _: 1
                }),
                _createVNode(_Transition, { name: "el-zoom-in-center" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_el_button, {
                      loading: _ctx.loading,
                      type: "success",
                      "native-type": "submit",
                      class: "login"
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode(" Anmelden ")
                      ])),
                      _: 1
                    }, 8, ["loading"]), [
                      [_vShow, _ctx.showButton]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "onSubmit"])
          ], 512), [
            [_vShow, _ctx.showLogin]
          ])
        ]),
        _: 1
      }),
      (_ctx.failCount >= 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createTextVNode(" Passwort vergessen? ")),
            _createElementVNode("span", {
              class: "reset-link",
              onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.onResetClick && _ctx.onResetClick(...args)))
            }, " Hier zurücksetzen.")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}